import { render, staticRenderFns } from "./section-results-lazy-load-anchor.vue?vue&type=template&id=877a970e&scoped=true&"
import script from "./section-results-lazy-load-anchor.vue?vue&type=script&lang=js&"
export * from "./section-results-lazy-load-anchor.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "877a970e",
  null
  ,true
)

export default component.exports